/** Small utilities for scent family chips on product cards. */

const FAMILIES = [
  { key: 'floral',   match: ['floral','rose','jasmine','peony','lily','tuberose','iris','violet','geranium'] },
  { key: 'citrus',   match: ['citrus','bergamot','lemon','orange','grapefruit','lime','mandarin','yuzu'] },
  { key: 'oud',      match: ['oud','agarwood'] },
  { key: 'woody',    match: ['woody','wood','sandalwood','cedar','vetiver','patchouli','guaiac'] },
  { key: 'fresh',    match: ['fresh','aquatic','marine','sea','ozonic','mint'] },
  { key: 'sweet',    match: ['sweet','vanilla','tonka','caramel','honey','sugar'] },
  { key: 'spicy',    match: ['spicy','spice','pepper','cinnamon','cardamom','clove','saffron','ginger'] },
  { key: 'musk',     match: ['musk','ambroxan','ambrette'] },
  { key: 'aquatic',  match: ['aquatic','marine','calone'] },
  { key: 'gourmand', match: ['gourmand','cocoa','chocolate','coffee','almond','cherry','toffee','pistachio'] },
];

const LABEL = {
  floral: 'Floral', citrus: 'Citrus', oud: 'Oud', woody: 'Woody',
  fresh: 'Fresh', sweet: 'Sweet', spicy: 'Spicy', musk: 'Musk',
  aquatic: 'Aquatic', gourmand: 'Gourmand',
};

/** Derive up to 2 scent families from a product's notes / scent_family / vibe text. */
export function getScentFamilies(product, max = 2) {
  if (!product) return [];
  const explicit = (product.scent_family || product.family || '').toString().toLowerCase();
  if (explicit && FAMILIES.find(f => f.key === explicit)) return [explicit];

  const blob = [
    product.scent_family, product.family,
    ...(Array.isArray(product.notes) ? product.notes : []),
    ...(product.notes?.top || []),
    ...(product.notes?.middle || product.notes?.heart || []),
    ...(product.notes?.base || []),
    ...(product.top_notes || []),
    ...(product.middle_notes || []),
    ...(product.heart_notes || []),
    ...(product.base_notes || []),
    product.description, product.vibe, product.tagline,
  ].filter(Boolean).join(' ').toLowerCase();

  const found = [];
  for (const fam of FAMILIES) {
    if (fam.match.some(m => blob.includes(m))) found.push(fam.key);
    if (found.length >= max) break;
  }
  return found;
}

export function ScentChip({ family }) {
  if (!family) return null;
  return (
    <span className={`scent-chip scent-${family}`} data-testid={`scent-chip-${family}`}>
      {LABEL[family] || family}
    </span>
  );
}
